const SortableCtor = window.Sortable?.default || window.Sortable;

if (!SortableCtor) {
    throw new Error("SortableJS global was not found. Make sure Sortable.min.js is loaded before widget bundles.");
}

export default SortableCtor;